export const translations = {
  es: {
    waUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hola Elba, vi tu página web y me interesa agendar una consulta."),
    headerCta: "Quiero mi guía",
    kicker: "Psicología Clínica · Presencial y Teleconsulta",
    heroA: "Tu mente también",
    heroB: "merece una",
    heroAccent: "pausa.",
    intro1: "Soy ",
    introStrong: "Elba Rojas, psicóloga",
    intro2: ". Deja tus datos en menos de un minuto y descarga gratis mi ",
    introStrong2: "Guía Práctica Antiestrés",
    intro3: ", con técnicas sencillas para manejar el estrés del día a día.",
    ctaPrimary: "Descargar mi guía gratis",
    ctaWhats: "Habla con Elba",
    floatingWhats: "Agenda tu cita",
    photoBadgeSub: "Mág. Psicología Clínica · +15 años",
    creds: [
      { title: "+15 años de experiencia", sub: "Atención a niños, adultos y parejas" },
      { title: "Egresada cum laude", sub: "Universidad de San Petersburgo, Rusia" },
      { title: "Magíster en Psicología Clínica", sub: "Especialidad en Psicología Correctiva" },
      { title: "Trilingüe", sub: "Español · Inglés · Ruso" },
    ],
    trust: ["Solo toma 30 segundos", "Descarga inmediata", "Datos confidenciales"],
    stripGift: "Tu regalo:",
    stripGiftName: "Guía Práctica Antiestrés",
    stripItems: ["Respiración para calmar el cuerpo", "Técnicas contra la mente acelerada", "Plan práctico para el día a día"],
    stripNote: "PDF gratis al dejar tus datos · Descarga inmediata",
    servicesTitle: "¿En qué puedo",
    servicesAccent: "ayudarte?",
    servicesSub: "Niños · Adolescentes · Adultos · Parejas",
    services: ["Ansiedad y depresión", "Manejo de estrés", "Terapia de parejas", "Terapia parental", "Traumas y duelo", "Teleconsulta a domicilio"],
    groupsTitle: "¿Charlas para tu grupo?",
    groupsText: "Talleres y charlas de manejo del estrés y bienestar emocional para empresas, escuelas y ONGs. En español, inglés o ruso.",
    groupsCta: "Consultar para grupos",
    groupsWaUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hola Elba, me interesa una charla o taller de bienestar para un grupo (empresa / escuela / ONG)."),
    formKicker: "Un solo paso",
    formTitle: "Deja tus datos y llévate la",
    formAccent: "guía gratis",
    formSub: "Elba podrá contactarte para orientarte y agendar una consulta. Como agradecimiento, la guía se descarga al instante.",
    stepsTitle: "Cómo es",
    stepsAccent: "trabajar conmigo",
    stepsLead: "Un espacio sin juicio: quienes consultan con Elba destacan su calidez humana, su ética profesional y lo cómodos que se sienten desde la primera sesión.",
    steps: [
      { n: "01", title: "Escríbeme o deja tus datos", text: "Por WhatsApp o con el formulario de abajo. Te respondo personalmente, sin ningún compromiso." },
      { n: "02", title: "Primera evaluación", text: "Una sesión para conocerte, entender qué te trae a consulta y resolver todas tus dudas con calma." },
      { n: "03", title: "Plan personalizado", text: "Definimos juntos el ritmo y la modalidad de tus sesiones: presencial, teleconsulta o a domicilio." },
    ],
    faqTitle: "Preguntas",
    faqAccent: "frecuentes",
    faq: [
      { q: "¿Cuánto dura una sesión?", a: "Las sesiones individuales duran 60 minutos. Las consultas de pareja o familiares duran 90 minutos, para dar espacio a todas las voces con calma." },
      { q: "¿Cuánto cuesta una consulta?", a: "La consulta individual tiene un valor de $65. Las consultas de pareja o familiares, de $80 (90 minutos). Escríbeme por WhatsApp y te confirmo disponibilidad." },
      { q: "¿Cómo funciona la teleconsulta?", a: "Por videollamada segura, con la misma calidez y confidencialidad de una sesión presencial. Solo necesitas un lugar tranquilo y buena conexión." },
      { q: "¿Atiendes niños y adolescentes?", a: "Sí. Atiendo niños, adolescentes, adultos y parejas, con enfoques adaptados a cada etapa de la vida." },
      { q: "¿Todo lo que cuente es confidencial?", a: "Absolutamente. Todo lo que compartas está protegido por el secreto profesional. Este es un espacio seguro y sin juicio." },
      { q: "¿Dónde queda el consultorio?", a: "En PH Medical Plaza, Piso 3. También ofrezco teleconsulta y atención a domicilio si te resulta más cómodo." },
    ],
    lf: {
      title: "Quiero mi Guía Antiestrés",
      sub: "Completa tus datos y la descarga se habilita al instante.",
      nombre: "Nombre completo *",
      nombrePh: "Ej. María González",
      telefono: "Teléfono / WhatsApp *",
      telefonoPh: "Ej. 55 1234 5678",
      edad: "Edad *",
      edadPh: "Ej. 32",
      motivo: "¿Qué te acerca a psicología? *",
      motivoPh: "Selecciona una opción general",
      motivos: [
        { v: "Estrés o ansiedad", l: "Estrés o ansiedad" },
        { v: "Problemas de sueño", l: "Problemas de sueño" },
        { v: "Relaciones personales o familiares", l: "Relaciones personales o familiares" },
        { v: "Autoestima y confianza", l: "Autoestima y confianza" },
        { v: "Duelo o pérdida", l: "Duelo o pérdida" },
        { v: "Orientación personal", l: "Orientación personal" },
        { v: "Solo quiero información", l: "Solo quiero información" },
        { v: "Otro", l: "Otro" },
      ],
      submit: "Enviar y descargar mi guía",
      errorMotivo: "Selecciona el motivo de tu interés",
      successToast: "¡Datos enviados! Tu guía está lista.",
      privacy: "Tus datos son confidenciales: solo los verá Elba.",
    },
    sc: {
      thanks: "¡Gracias",
      body1: "Gracias por dar este paso. Te escribiré personalmente muy pronto; será un gusto acompañarte en tu proceso. Mientras tanto, aquí tienes tu",
      bodyStrong: "Guía Práctica Antiestrés",
      body2: ": descárgala y empieza hoy.",
      download: "Descargar la guía (PDF)",
      downloadPath: "/guia.pdf",
      downloadName: "Guia-Practica-Antiestres.pdf",
      whats: "Habla con Elba",
      note: "Te estaré contactando dentro del siguiente día",
      waUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hola Elba, acabo de dejar mis datos en tu página web y me interesa una consulta."),
    },
    footer: {
      role: "Psicóloga",
      services: "Evaluación psicológica, intervención y psicoterapia focalizada. Atención a niños, adolescentes, adultos y parejas.",
      contactTitle: "Contacto",
      phone: "Para citas: 6248-5277 / 915-0505 Ext. 3000",
      hoursTitle: "Horarios",
      hours: "Lunes a viernes de 10am a 5pm · Sábado de 9am a 2pm",
      tele: "Teleconsulta y atención a domicilio",
      disclaimer: "La Guía Antiestrés es material educativo y no sustituye la atención psicológica profesional.",
      adminLink: "Acceso profesional",
    },
  },
  en: {
    waUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hi Elba, I saw your website and I'd like to book a consultation."),
    headerCta: "Get my guide",
    kicker: "Clinical Psychology · In-Person & Online",
    heroA: "Your mind also",
    heroB: "deserves a",
    heroAccent: "pause.",
    intro1: "I'm ",
    introStrong: "Elba Rojas, psychologist",
    intro2: ". Leave your details in under a minute and download my ",
    introStrong2: "Practical Anti-Stress Guide",
    intro3: " for free — simple techniques to manage everyday stress.",
    ctaPrimary: "Download my free guide",
    ctaWhats: "Chat with Elba",
    floatingWhats: "Book your appointment",
    photoBadgeSub: "M.Sc. Clinical Psychology · +15 years",
    creds: [
      { title: "+15 years of experience", sub: "Care for children, adults and couples" },
      { title: "Cum laude graduate", sub: "St. Petersburg University, Russia" },
      { title: "M.Sc. in Clinical Psychology", sub: "Specialty in Corrective Psychology" },
      { title: "Trilingual", sub: "Spanish · English · Russian" },
    ],
    trust: ["Takes just 30 seconds", "Instant download", "Confidential data"],
    stripGift: "Your gift:",
    stripGiftName: "Practical Anti-Stress Guide",
    stripItems: ["Breathing to calm your body", "Techniques for a racing mind", "A practical day-to-day plan"],
    stripNote: "Free PDF when you leave your details · Instant download",
    servicesTitle: "How can I",
    servicesAccent: "help you?",
    servicesSub: "Children · Teens · Adults · Couples",
    services: ["Anxiety & depression", "Stress management", "Couples therapy", "Parenting support", "Trauma & grief", "Teleconsultation & home visits"],
    groupsTitle: "Talks for your group?",
    groupsText: "Workshops and talks on stress management and emotional well-being for companies, schools and NGOs. In Spanish, English or Russian.",
    groupsCta: "Ask about group talks",
    groupsWaUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hi Elba, I'm interested in a wellness talk or workshop for a group (company / school / NGO)."),
    formKicker: "Just one step",
    formTitle: "Leave your details and get the",
    formAccent: "free guide",
    formSub: "Elba may reach out to guide you and book a consultation. As a thank-you, the guide downloads instantly.",
    stepsTitle: "What it's like",
    stepsAccent: "working with me",
    stepsLead: "A judgment-free space: Elba's patients highlight her warmth, her professional ethics, and how comfortable they feel from the very first session.",
    steps: [
      { n: "01", title: "Message me or leave your details", text: "Via WhatsApp or the form below. I personally reply, with no strings attached." },
      { n: "02", title: "First evaluation", text: "A session to get to know you, understand what brings you in, and calmly answer all your questions." },
      { n: "03", title: "Personalized plan", text: "Together we set the pace and format of your sessions: in-person, teleconsultation or home visits." },
    ],
    faqTitle: "Frequently asked",
    faqAccent: "questions",
    faq: [
      { q: "How long is a session?", a: "Individual sessions last 60 minutes. Couples or family consultations last 90 minutes, so every voice has room to be heard calmly." },
      { q: "How much is a consultation?", a: "Individual sessions are $80. Couples or family consultations are $100 (90 minutes). Message me on WhatsApp and I'll confirm availability." },
      { q: "How does teleconsultation work?", a: "Through a secure video call, with the same warmth and confidentiality as an in-person session. You just need a quiet place and a good connection." },
      { q: "Do you see children and teens?", a: "Yes. I work with children, teens, adults and couples, with approaches adapted to every stage of life." },
      { q: "Is everything I share confidential?", a: "Absolutely. Everything you share is protected by professional confidentiality. This is a safe, judgment-free space." },
      { q: "Where is the office?", a: "At PH Medical Plaza, 3rd floor. I also offer teleconsultation and home visits if that's more comfortable for you." },
    ],
    lf: {
      title: "I want my Anti-Stress Guide",
      sub: "Fill in your details and the download unlocks instantly.",
      nombre: "Full name *",
      nombrePh: "E.g. Mary Smith",
      telefono: "Phone / WhatsApp *",
      telefonoPh: "E.g. +1 555 123 4567",
      edad: "Age *",
      edadPh: "E.g. 32",
      motivo: "What brings you to psychology? *",
      motivoPh: "Choose a general option",
      motivos: [
        { v: "Estrés o ansiedad", l: "Stress or anxiety" },
        { v: "Problemas de sueño", l: "Sleep issues" },
        { v: "Relaciones personales o familiares", l: "Personal or family relationships" },
        { v: "Autoestima y confianza", l: "Self-esteem & confidence" },
        { v: "Duelo o pérdida", l: "Grief or loss" },
        { v: "Orientación personal", l: "Personal guidance" },
        { v: "Solo quiero información", l: "I just want information" },
        { v: "Otro", l: "Other" },
      ],
      submit: "Send & download my guide",
      errorMotivo: "Please select your reason",
      successToast: "Details sent! Your guide is ready.",
      privacy: "Your data is confidential: only Elba will see it.",
    },
    sc: {
      thanks: "Thank you",
      body1: "Thank you for taking this step. I'll personally reach out to you very soon — it will be a pleasure to walk with you through your process. In the meantime, here is your",
      bodyStrong: "Practical Anti-Stress Guide",
      body2: ": download it and start today.",
      download: "Download the guide (PDF · English)",
      downloadPath: "/guia-en.pdf",
      downloadName: "Practical-Anti-Stress-Guide.pdf",
      whats: "Chat with Elba",
      note: "I'll be in touch within the next day",
      waUrl: "https://wa.me/50762485277?text=" + encodeURIComponent("Hi Elba, I just left my details on your website and I'm interested in a consultation."),
    },
    footer: {
      role: "Psychologist",
      services: "Psychological assessment, intervention and focused psychotherapy. Care for children, teens, adults and couples.",
      contactTitle: "Contact",
      phone: "Appointments: 6248-5277 / 915-0505 Ext. 3000",
      hoursTitle: "Hours",
      hours: "Monday to Friday 10am–5pm · Saturday 9am–2pm",
      tele: "Teleconsultation and home visits",
      disclaimer: "The Anti-Stress Guide is educational material and does not replace professional psychological care.",
      adminLink: "Professional access",
    },
  },
};
